'use client'
import { Button } from '@/components/ui/button'
import { CopyIcon } from '@payloadcms/ui/icons/Copy'
import { useState } from 'react'
import { useTranslations } from 'next-intl'

export function CopyButton({ code }: { code: string }) {
  const t = useTranslations('Code')
  const [copied, setCopied] = useState(false)

  function updateCopyStatus() {
    if (!copied) {
      setCopied(true)
      setTimeout(() => setCopied(false), 1000)
    }
  }

  return (
    <div className="flex items-center justify-end">
      <Button
        className="flex gap-1"
        variant={'secondary'}
        onClick={async () => {
          await navigator.clipboard.writeText(code)
          updateCopyStatus()
        }}
      >
        <span aria-live="polite">{copied ? t('copied') : t('copy')}</span>
        <CopyIcon />
      </Button>
    </div>
  )
}
